import Vue from "vue";
import Router from "vue-router";
import layout from "@/view/index";
import axios from "@/http/axios.js";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: "/app",
  routes: [
    {
      path: "/",
      redirect: "/userInfo/workTable",
      component: { template: "<router-view></router-view>" },
      children: [
        {
          path: ":id/login",
          meta: {
            title: "登录",
          },
          component: (resolve) => require(["@/view/login.vue"], resolve),
        },
        {
          path: "login",
          meta: {
            title: "登录",
          },
          component: (resolve) => require(["@/view/login.vue"], resolve),
        },
        {
          path: ":id/bdhsso",
          meta: {
            title: "授权",
          },
          component: (resolve) => require(["@/view/bdhsso.vue"], resolve),
        },
        {
          path: "/loginLoading",
          meta: {
            title: "登录跳转",
          },
          component: (resolve) => require(["@/view/loginLoading.vue"], resolve),
        },
        {
          path: "/b-platform",
          meta: {
            title: "登录跳转",
          },
          component: (resolve) => require(["@/view/b-platform.vue"], resolve),
        },
              {
          path: "/loginRedirect",
          meta: {
            title: "登录鉴权",
          },
          component: (resolve) => require(["@/view/loginRedirect.vue"], resolve),
        },
        {
          path: "/noFrame/:name",
          meta: {
            title: "渔之蓝",
          },
          component: (resolve) =>
            require(["@/components/layout/noFrame.vue"], resolve),
        },
        {
          path: "/teacherSpace/:name",
          meta: {
            title: "渔之蓝",
          },
          component: (resolve) =>
            require(["@/components/layout/teacherSpace.vue"], resolve),
        },
        {
          path: "register",
          meta: {
            title: "非学历注册",
          },
          component: (resolve) =>
            require(["@/view/register.vue"], resolve),
        },
        {
          path: "forgetPassword",
          meta: {
            title: "找回密码",
          },
          component: (resolve) =>
            require(["@/view/forgetPassword.vue"], resolve),
        },
      ],
    },
    {
      path: "/",
      meta: { title: "加载中" },
      component: layout,
      children: [
        {
          path: "userInfo",
          component: { template: "<router-view></router-view>" },
          children: [
            {
              path: "index",
              meta: {
                title: "个人中心",
              },
              component: (resolve) =>
                require(["@/view/userInfo/index.vue"], resolve),
            },
            {
              path: "workTable",
              meta: {
                title: "工作台",
              },
              component: (resolve) =>
                require(["@/view/userInfo/workTable.vue"], resolve),
            },
          ],
        },
        {
          path: "*",
          name: "app",
          meta: {
            title: "",
          },
          component: (resolve) =>
            require(["@/components/layout/main.vue"], resolve),
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let user = JSON.parse(localStorage.getItem("user"));
  document.title = `${to.meta.title || "加载中..."}-${
    user?.sysName || user?.tenantName || "继续教育"
  }`;
  next();
});

export default router;
